var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisplayBlueIcn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:3px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.601,
    y2: 1.336,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3458f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#244afe"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.367 0.394)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 21,
    height: 21,
    rx: 4,
    transform: "translate(-0.367 -0.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-20308.572-24666.176l4.932,4.844,5.045-4.844",
    transform: "translate(20313.76 24674.699)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayBlueIcn);
export default __webpack_public_path__ + "static/media/display-blue-icn.efe97c713d3437500c9fcf15de5a955f.svg";
export { ForwardRef as ReactComponent };